module.exports = __webpack_public_path__ + "img/logo.3d04f7e7.png";